let commands = function () {
  return <div className="fragmentContainer">This is the Commands page</div>;
};

export default commands;
